// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3BG1c","list":"PatternAutocomplete_list__23dU5"};